
export const getFormattedNumber = (num: number) => {
  return new Intl.NumberFormat('en-IN', {
    notation: 'compact',
    compactDisplay: 'short',
    // style: '',
    // currency: ''
  }).format(num).replace('T', 'K');
};

export const getFormattedUSNumber = (number) => {
  if (!number) return number;
  // Return the sanitized number string
  return number.toString().replace(/\s|\.|,/g, '');
};

// Todo: need to future referance

// export const getFormattedUSNumber = (number) => {
//   if(!number) return number;
//   let num = '';
//   let str = number.toString().replace(' ','').replace('.','').replace(',','');
//   if(str.length > 16) {
//     while(str.length > 16) {
//       num+=getFormattedUSNumber(parseInt(str.substring(0,16)));
//       str = str.substring(16, str.length);
//     }
//     return num + getFormattedUSNumber(parseInt(str));
//   } else {
//     return new Intl.NumberFormat('en-US', {
//       maximumFractionDigits: 0,
//       minimumFractionDigits: 0
//     }).format(str);
//   }
// };
/**
 * @description This function returns formatted follower label as per design
 *              from followerCountOptions define inside const file,
 *              based on follower min and max count.
 *              If min and max not present then returns empty string.
 * @param follower object contains min and max follower count
 * @returns formatted follower count label eg. "Less than 1k"
 */


// formatNumber(500) returns "500"
// formatNumber(1000) returns "1k"
// formatNumber(1500) returns "1.5k"
// formatNumber(2000) returns "2k"
// formatNumber(10000) returns "10k"
// formatNumber(10500) returns "10.5k"
// formatNumber(1000000) returns "1m"
// formatNumber(1250000) returns "1.3m"
// formatNumber(2000000) returns "2m"
// formatNumber(2500000) returns "2.5m"
// formatNumber(3000000) returns "3m"

export const formatNumber = (num) => {
  if (num >= 1000000) {
    return num % 1000000 === 0 ? (num / 1000000) + 'm' : (num / 1000000).toFixed(1) + 'm';
  } else if (num >= 1000) {
    return num % 1000 === 0 ? (num / 1000) + 'k' : (num / 1000).toFixed(1) + 'k';
  }
  return num.toString();
};

export const getFormattedNumberOfSubscriber = (
  follower: {
    min: number,
    max: number
  }): string => {

  if (!follower.min && !follower.max) {
    return '';
  }

  // Format the min and max values
  const formattedMin = formatNumber(follower.min);
  const formattedMax = formatNumber(follower.max);
  // Combine the formatted values
  const value = `${formattedMin} to ${formattedMax}`;

  return value;
};

